import * as React from "react"
const UiUxsvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      enableBackground: "new 0 0 512 512",
    }}
    viewBox="0 0 512 512"
    {...props}
  >
    <path d="M467 1H45C20.2 1 0 21.2 0 46v420c0 24.8 20.2 45 45 45h422c24.8 0 45-20.2 45-45V46c0-24.8-20.2-45-45-45zM45 31h422c8.3 0 15 6.7 15 15v75H30V46c0-8.3 6.7-15 15-15zm422 450H45c-8.3 0-15-6.7-15-15V151h452v315c0 8.3-6.7 15-15 15z" />
    <path d="M436 181H76c-8.3 0-15 6.7-15 15v90c0 8.3 6.7 15 15 15h360c8.3 0 15-6.7 15-15v-90c0-8.3-6.7-15-15-15zM226 331H76c-8.3 0-15 6.7-15 15v90c0 8.3 6.7 15 15 15h150c8.3 0 15-6.7 15-15v-90c0-8.3-6.7-15-15-15z" />
    <circle cx={76} cy={76} r={15} />
    <circle cx={136} cy={76} r={15} />
    <circle cx={196} cy={76} r={15} />
    <path d="M346 91h90c8.3 0 15-6.7 15-15s-6.7-15-15-15h-90c-8.3 0-15 6.7-15 15s6.7 15 15 15zM436 331H286c-8.3 0-15 6.7-15 15v90c0 8.3 6.7 15 15 15h150c8.3 0 15-6.7 15-15v-90c0-8.3-6.7-15-15-15z" />
  </svg>
)
export default UiUxsvg
